export default __webpack_public_path__ + "static/arindamLehri17-db06e4bf9f7d96005cc1d325ad4dd5f0.jpg";